import { atom } from 'recoil';

export type EnvToggleType = 'test' | 'live';

export const EnvToggleAtom = atom({
  key: 'envToggle',
  default: (localStorage.getItem('toggledEnv') || 'test') as EnvToggleType,
});
